import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const clientexservicoFindAllById = async (cliId) => {
    const headers = { "Content-Type": "application/json" };
    const data = await axios.get(url + `/v1/clientexservico/findbyid/${cliId}`, {
        headers,
    });
};

export const clientexservicoInsert = async (cliId, body) => {
    return await axios.post(url + `/v1/clientexservico/insert/${cliId}`, body);
};

export const clientexservicoDispEmUso = async (cliId) => {
    try {
        const headers = { "Content-Type": "application/json" };
        const data = await axios.get(
            url + `/v1/clientexservico/disponivelemuso/${cliId}`,
            {
                headers,
            }
        );
        console.log(data);
        return data;
    } catch (err) {
        console.log(err);
    }
};
